import env from "react-dotenv";

export const BACKEND_PROTO_HOST = "https://api.ценапосылки.рф";
export const BACKEND_PORT = 443;

export const BACKEND_URL = `${env.BACKEND_PROTO_HOST ?? BACKEND_PROTO_HOST}:${
  env.BACKEND_PORT ?? BACKEND_PORT
}`;
